import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorage } from 'ngx-store';
import { AuthService } from '../services/auth.service';

@Injectable({
	providedIn: 'root'
})
export class AuthGuard implements CanActivate {
	@LocalStorage('logged') logged: boolean = false;

	constructor(public router: Router, private auth: AuthService) { }

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

		if(this.auth.check()){
			this.logged = true;
			this.auth.loggedIn("ok");
			return true;
		}	
		this.router.navigate(['login']);
		return true;

		//Antes do Token
		/*if (!this.logged) {
			this.router.navigate(['login']); // consigo usar state?
			return false;
		}*/
		
	}
}
